import styled from 'styled-components';

const StyledGuardianSelectLimiter = styled.div`
   width: 300px;
`;
StyledGuardianSelectLimiter.displayName = 'StyledGuardianSelectLimiter';

export { StyledGuardianSelectLimiter };
